import { messages } from './messages';

export const ANNUAL_COUPON = 'hol2026_Web_annual50_Banner';
export const FIRST_MONTH_COUPON = 'BF2026A';

type BannerCopy = {
	title: (typeof messages)['firstMonthTitle'];
	cta: (typeof messages)['firstMonthCta'];
};

const COPY_BY_COUPON: Record<string, BannerCopy> = {
	[ANNUAL_COUPON]: { title: messages.annualTitle, cta: messages.annualCta },
	[FIRST_MONTH_COUPON]: { title: messages.firstMonthTitle, cta: messages.firstMonthCta },
};

export const getBannerCopy = (coupon: string | null): BannerCopy | undefined =>
	coupon ? COPY_BY_COUPON[coupon] : undefined;
